import defaultTheme from './defaultTheme';
const oldNavyTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#004779', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#004779', background: '#004779' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#004779' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#004779', border: '#004779', background: '#004779' }), field: {
        focus: '#004779',
        label: '#004779',
        icon: '#004779',
    } });
export default oldNavyTheme;
